export default {
  header: "Grease up those creative cogs of yours!",
  view: "startDrawing",
  artist: "DEFAULT ARTIST",
  progress: -1,
  fruit: "Apple",
  nouns: [],
  verbs: [],
  adjectives: []
};
